export const VIP_LEVEL = {
  0: "青铜",
  1: "白银",
  2: "黄金",
  3: "铂金",
  4: "白钻",
  5: "粉钻",
  6: "金钻",
  7: "紫钻",
  8: "星耀",
  9: "辉耀",
  10: "至尊",
};

export const NO_MENUS_URLS = [
  "/agreement",
  "/privacy",
  "/services",
  "/children",
  "/sharegame",
  "/threeshare",
  "/person"
];